module.exports = __webpack_public_path__ + "static/media/the-highwayman.e7b348be.png";